import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: { name: 'loginAfter' },
  },
  {
    path: '/empty',
    name: 'empty',
    component: () => import('../views/Empty.vue'),
  },
  {
    path: '/loginAfter',
    name: 'loginAfter',
    component: () => import('../views/LoginAfter.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/links',
    name: 'links',
    component: () => import('../views/Links.vue'),
  },
];

const router = new VueRouter({
  routes
})

export default router
